var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/withTranslation.tsx
import React from "react";

// src/types.ts
var SecurityMethodFlag = /* @__PURE__ */ ((SecurityMethodFlag3) => {
  SecurityMethodFlag3["SMS"] = "sms";
  SecurityMethodFlag3["Slider"] = "image";
  SecurityMethodFlag3["Email"] = "email";
  SecurityMethodFlag3["SMSWithEmail"] = "sms_email";
  SecurityMethodFlag3["DateOfBirth"] = "birthday";
  return SecurityMethodFlag3;
})(SecurityMethodFlag || {});
var FormattedStatus = /* @__PURE__ */ ((FormattedStatus2) => {
  FormattedStatus2["Pending"] = "pending";
  FormattedStatus2["Pass"] = "pass";
  FormattedStatus2["Rejected"] = "rejected";
  FormattedStatus2["RejectedWithoutRetry"] = "rejectedWithoutRetry";
  FormattedStatus2["NetworkError"] = "networkError";
  FormattedStatus2["Unknown"] = "unknown";
  return FormattedStatus2;
})(FormattedStatus || {});

// src/locales/en.ts
var locales = {
  global: {
    \u5B89\u5168\u6821\u9A8C: "Security Verification",
    "\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD": "Your account is a valuable asset. To protect your account security, we need to verify your identity.",
    \u6ED1\u5757\u9A8C\u8BC1: "Slider Verification",
    \u77ED\u4FE1\u9A8C\u8BC1: "SMS Verification",
    \u90AE\u7BB1\u9A8C\u8BC1: "Email Verification",
    \u51FA\u751F\u65E5\u671F\u9A8C\u8BC1: "Date of Birth Verification",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "Requests are too frequent. Please try again later."
  },
  ["image" /* Slider */]: {
    "\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE": "For your account safety, please drag the slider below to complete the puzzle piece.",
    "\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01": "Great! Time used {value} seconds!",
    \u6CA1\u6709\u5BF9\u51C6\u5462: "Not aligned",
    "\u6709\u70B9\u96BE\u5462\uFF0C\u5DF2\u66F4\u6362\u9898\u76EE": "It's a bit difficult. The subject has been changed.",
    \u64CD\u4F5C\u6B65\u9AA4: "Steps",
    "\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904": "1.Hold the slider and slide it to the right until the puzzle is aligned.",
    "\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1": "2. Release your finger and complete verification.",
    \u5C1D\u8BD5\u592A\u591A\u4E86: "Too many attempts",
    xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801: "The verification code will be automatically refreshed after {value} seconds",
    "\u7F51\u7EDC\u5F02\u5E38, \u8BF7\u5237\u65B0": "Network error. Please refresh.",
    \u52A0\u8F7D\u4E2D: "Loading"
  },
  ["sms" /* SMS */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Please enter the verification code",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "SMS will be sent to",
    \u9A8C\u8BC1\u7801: "Verification Code",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Please enter the verification code correctly",
    \u91CD\u65B0\u53D1\u9001: "Resend",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Resend after",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Switch to SMS Verification",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Switch to Email Verification",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "Requests are too frequent. Please try again later."
  },
  ["email" /* Email */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Please enter the verification code",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "We will send the verification code to your email address",
    \u9A8C\u8BC1\u7801: "Verification Code",
    \u91CD\u65B0\u53D1\u9001: "Resend",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Please enter the verification code correctly",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Resend after",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Switch to SMS Verification",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Switch to Email Verification"
  },
  ["sms_email" /* SMSWithEmail */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Please enter the verification code",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "We will send the verification code to your email address",
    \u9A8C\u8BC1\u7801: "Verification Code",
    \u91CD\u65B0\u53D1\u9001: "Resend",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Please enter the verification code correctly",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Resend after",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Switch to SMS Verification",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Switch to Email Verification",
    \u77ED\u4FE1\u9A8C\u8BC1: "SMS Verification",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "SMS will be sent to"
  },
  ["birthday" /* DateOfBirth */]: {
    \u8EAB\u4EFD\u9A8C\u8BC1: "Identity Verification",
    "\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)": "Date of Birth (DD/MM/YY)",
    \u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F: "Please enter the correct date of birth",
    \u63D0\u4EA4: "Submit"
  }
};

// src/locales/de.ts
var locales2 = {
  global: {
    \u5B89\u5168\u6821\u9A8C: "Sicherheitspr\xFCfung",
    "\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD": "Um die Sicherheit deines Kontos zu sch\xFCtzen, m\xFCssen wir deine Identit\xE4t \xFCberpr\xFCfen.",
    \u6ED1\u5757\u9A8C\u8BC1: "Schiebe-Verifizierung",
    \u77ED\u4FE1\u9A8C\u8BC1: "SMS-Verifizierung",
    \u90AE\u7BB1\u9A8C\u8BC1: "E-Mail-Verifizierung",
    \u51FA\u751F\u65E5\u671F\u9A8C\u8BC1: "Verifizierung des Geburtsdatums",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "Der Vorgang wurde zu h\xE4ufig durchgef\xFChrt. Bitte versuche es sp\xE4ter noch einmal."
  },
  ["image" /* Slider */]: {
    "\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE": "Zur Sicherheit deines Kontos, ziehe den Schieberegler, damit das Puzzleteil passt.",
    "\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01": "Sehr gut! Zeit: {value} Sekunden!",
    \u6CA1\u6709\u5BF9\u51C6\u5462: "Nicht ausgerichtet",
    "\u6709\u70B9\u96BE\u5462\uFF0C\u5DF2\u66F4\u6362\u9898\u76EE": "Es ist ein bisschen schwierig. Das Thema ist ge\xE4ndert worden.",
    \u64CD\u4F5C\u6B65\u9AA4: "Schritte",
    "\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904": "1.Halte den Schieberegler gedr\xFCckt und schiebe ihn nach rechts, bis das Puzzle ausgerichtet ist.",
    "\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1": "2.Lasse deinen Finger los und schlie\xDFe die Verifizierung ab.",
    \u5C1D\u8BD5\u592A\u591A\u4E86: "Zu viele Versuche",
    xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801: "Der Verifizierungscode wird nach {value} Sekunden automatisch erneuert.",
    "\u7F51\u7EDC\u5F02\u5E38, \u8BF7\u5237\u65B0": "Netzwerkanomalie. Bitte aktualisiere die Seite.",
    \u52A0\u8F7D\u4E2D: "Wird geladen..."
  },
  ["sms" /* SMS */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Bitte gib den Verifizierungscode ein",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Der SMS-Verifizierungscode wird gesendet an",
    \u9A8C\u8BC1\u7801: "Verifizierungscode",
    \u91CD\u65B0\u53D1\u9001: "Erneut senden",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Erneut senden in",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Bitte gib den korrekten Verifizierungscode ein.",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Zur SMS-Verifizierung wechsel",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Zur E-Mail-Verifizierung wechseln"
  },
  ["email" /* Email */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Bitte gib den Verifizierungscode ein",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Wir senden dir den Verifizierungscode an deine E-Mail Adresse.",
    \u9A8C\u8BC1\u7801: "Verifizierungscode",
    \u91CD\u65B0\u53D1\u9001: "Erneut senden",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Erneut senden in",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Bitte gib den korrekten Verifizierungscode ein.",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Zur SMS-Verifizierung wechsel",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Zur E-Mail-Verifizierung wechseln"
  },
  ["sms_email" /* SMSWithEmail */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Bitte gib den Verifizierungscode ein",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Wir senden dir den Verifizierungscode an deine E-Mail Adresse.",
    \u9A8C\u8BC1\u7801: "Verifizierungscode",
    \u91CD\u65B0\u53D1\u9001: "Erneut senden",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Erneut senden in",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Bitte gib den korrekten Verifizierungscode ein.",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Zur SMS-Verifizierung wechsel",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Zur E-Mail-Verifizierung wechseln",
    \u77ED\u4FE1\u9A8C\u8BC1: "SMS-Verifizierung",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Der SMS-Verifizierungscode wird gesendet an"
  },
  ["birthday" /* DateOfBirth */]: {
    \u8EAB\u4EFD\u9A8C\u8BC1: "Identit\xE4tspr\xFCfung",
    "\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)": "Geburtsdatum (DD/MM/YY)",
    \u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F: "Bitte gib das korrekte Geburtsdatum ein.",
    \u63D0\u4EA4: "Best\xE4tigen"
  }
};

// src/locales/es.ts
var locales3 = {
  global: {
    \u5B89\u5168\u6821\u9A8C: "Verificaci\xF3n de Seguridad",
    "\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD": "Tu cuenta es un activo valioso. Para proteger tu seguridad, necesitamos verificar tu identidad.",
    \u6ED1\u5757\u9A8C\u8BC1: "Control de deslizador",
    \u77ED\u4FE1\u9A8C\u8BC1: "Verificaci\xF3n por SMS",
    \u90AE\u7BB1\u9A8C\u8BC1: "Verificaci\xF3n por correo electr\xF3nico",
    \u51FA\u751F\u65E5\u671F\u9A8C\u8BC1: "Verificaci\xF3n de la fecha de nacimiento",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "Las solicitudes son demasiado frecuentes. Por favor, int\xE9ntelo de nuevo m\xE1s tarde"
  },
  ["image" /* Slider */]: {
    "\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE": "Para la seguridad de tu cuenta, arrastra la pieza hasta que encaje en la imagen",
    "\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01": "\xA1Genial! \xA1Tiempo utilizado {value} segundos!",
    \u6CA1\u6709\u5BF9\u51C6\u5462: "La pieza no est\xE1 completamente encajada",
    "\u6709\u70B9\u96BE\u5462\uFF0C\u5DF2\u66F4\u6362\u9898\u76EE": "Es un poco dif\xEDcil. Se ha  modificado la prueba.",
    \u64CD\u4F5C\u6B65\u9AA4: "Pasos",
    "\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904": "1.Mant\xE9n el deslizador y desl\xEDzalo hacia la derecha hasta encajar el puzzle.",
    "\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1": "2.Suelta el dedo para completar la verificaci\xF3n.",
    \u5C1D\u8BD5\u592A\u591A\u4E86: "Demasiados intentos",
    xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801: "El c\xF3digo de verificaci\xF3n se actualizar\xE1 autom\xE1ticamente despu\xE9s de {value} segundos.",
    "\u7F51\u7EDC\u5F02\u5E38, \u8BF7\u5237\u65B0": "Anomal\xEDa en la red. Por favor, actualiza la p\xE1gina.",
    \u52A0\u8F7D\u4E2D: "Cargando"
  },
  ["sms" /* SMS */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Por favor ingresa el c\xF3digo de verificaci\xF3n",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "El c\xF3digo de verificaci\xF3n por SMS se enviar\xE1 a",
    \u9A8C\u8BC1\u7801: "C\xF3digo de verificaci\xF3n",
    \u91CD\u65B0\u53D1\u9001: "Reenviar",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Reenviar despu\xE9s de",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Por favor, introduce el c\xF3digo de verificaci\xF3n correcto."
  },
  ["email" /* Email */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Por favor ingresa el c\xF3digo de verificaci\xF3n",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Te enviaremos el c\xF3digo de verificaci\xF3n a tu direcci\xF3n de correo electr\xF3nico.",
    \u9A8C\u8BC1\u7801: "C\xF3digo de verificaci\xF3n",
    \u91CD\u65B0\u53D1\u9001: "Reenviar",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Reenviar despu\xE9s de",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Por favor, introduce el c\xF3digo de verificaci\xF3n correcto."
  },
  ["sms_email" /* SMSWithEmail */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Por favor ingresa el c\xF3digo de verificaci\xF3n",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "El c\xF3digo de verificaci\xF3n por SMS se enviar\xE1 a",
    \u9A8C\u8BC1\u7801: "C\xF3digo de verificaci\xF3n",
    \u91CD\u65B0\u53D1\u9001: "Reenviar",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Reenviar despu\xE9s de",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Por favor, introduce el c\xF3digo de verificaci\xF3n correcto.",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Te enviaremos el c\xF3digo de verificaci\xF3n a tu direcci\xF3n de correo electr\xF3nico.",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Cambiar a verificaci\xF3n por SMS",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Cambiar a verificaci\xF3n de correo electr\xF3nico"
  },
  ["birthday" /* DateOfBirth */]: {
    \u8EAB\u4EFD\u9A8C\u8BC1: "Verificaci\xF3n de identidad",
    "\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)": "Fecha de nacimiento (DD/MM/AA)",
    \u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F: "Por favor ingresa la fecha de nacimiento correcta",
    \u63D0\u4EA4: "Enviar"
  }
};

// src/locales/fr.ts
var locales4 = {
  global: {
    \u5B89\u5168\u6821\u9A8C: "V\xE9rification de s\xE9curit\xE9",
    "\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD": "Pour prot\xE9ger la s\xE9curit\xE9 de votre compte, nous devons v\xE9rifier votre identit\xE9.",
    \u6ED1\u5757\u9A8C\u8BC1: "V\xE9rification glisser-d\xE9poser ",
    \u77ED\u4FE1\u9A8C\u8BC1: "V\xE9rification par SMS",
    \u90AE\u7BB1\u9A8C\u8BC1: "V\xE9rification par e-mail",
    \u51FA\u751F\u65E5\u671F\u9A8C\u8BC1: "V\xE9rification par e-mail",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "L'op\xE9ration a \xE9t\xE9 effectu\xE9e trop de fois. Veuillez r\xE9essayer plus tard"
  },
  ["image" /* Slider */]: {
    "\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE": "Pour la s\xE9curit\xE9 de votre compte, veuillez faire glisser le curseur ci-dessous pour remettre la pi\xE8ce du puzzle \xE0 la bonne place.",
    "\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01": "Super ! Temps utilis\xE9 {value} secondes !",
    \u6CA1\u6709\u5BF9\u51C6\u5462: "Pas align\xE9",
    "\u6709\u70B9\u96BE\u5462\uFF0C\u5DF2\u66F4\u6362\u9898\u76EE": "C'est un peu difficile. Le sujet a \xE9t\xE9 chang\xE9.",
    \u64CD\u4F5C\u6B65\u9AA4: "\xC9tapes",
    "\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904": "1.Tenez le curseur et faites-le glisser vers la droite jusqu'\xE0 ce que le puzzle soit align\xE9.",
    "\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1": "2.Rel\xE2chez votre doigt et terminez la v\xE9rification.",
    \u5C1D\u8BD5\u592A\u591A\u4E86: "Trop de tentatives",
    xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801: "Le code de v\xE9rification sera automatiquement actualis\xE9 dans {value} secondes.",
    "\u7F51\u7EDC\u5F02\u5E38, \u8BF7\u5237\u65B0": "Probl\xE8me de r\xE9seau. Veuillez actualiser la page.",
    \u52A0\u8F7D\u4E2D: "Chargement en cours"
  },
  ["sms" /* SMS */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Veuillez entrer le code de v\xE9rification",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Le code de v\xE9rification via SMS sera envoy\xE9 \xE0",
    \u91CD\u65B0\u53D1\u9001: "Renvoyer",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Envoyer \xE0 Nouveau dans",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Veuillez saisir le code de v\xE9rification correct."
  },
  ["email" /* Email */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Veuillez entrer le code de v\xE9rification",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Nous allons vous envoyer le code de v\xE9rification \xE0 votre adresse e-mail.",
    \u91CD\u65B0\u53D1\u9001: "Renvoyer",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Envoyer \xE0 Nouveau dans",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Veuillez saisir le code de v\xE9rification correct."
  },
  ["sms_email" /* SMSWithEmail */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Veuillez entrer le code de v\xE9rification",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Le code de v\xE9rification via SMS sera envoy\xE9 \xE0",
    \u91CD\u65B0\u53D1\u9001: "Renvoyer",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Envoyer \xE0 Nouveau dans",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Veuillez saisir le code de v\xE9rification correct.",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Nous allons vous envoyer le code de v\xE9rification \xE0 votre adresse e-mail.",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Passez \xE0 la v\xE9rification par SMS",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Passez \xE0 la v\xE9rification par email"
  },
  ["birthday" /* DateOfBirth */]: {
    \u8EAB\u4EFD\u9A8C\u8BC1: "V\xE9rification de l'identit\xE9",
    "\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)": "Date de naissance (JJ/MM/AAAA)",
    \u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F: "Veuillez saisir la date de naissance correcte",
    \u63D0\u4EA4: "Soumettre"
  }
};

// src/locales/it.ts
var locales5 = {
  global: {
    \u5B89\u5168\u6821\u9A8C: "Verifica di sicurezza",
    "\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD": "Il tuo account \xE8 un bene prezioso. Per proteggere la sicurezza del tuo account, abbiamo bisogno di verificare la tua identit\xE0.",
    \u6ED1\u5757\u9A8C\u8BC1: "Verifica del cursore",
    \u77ED\u4FE1\u9A8C\u8BC1: "Verifica tramite SMS",
    \u90AE\u7BB1\u9A8C\u8BC1: "Verifica dell'e-mail",
    \u51FA\u751F\u65E5\u671F\u9A8C\u8BC1: "Verifica della data di nascita",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "L'operazione \xE8 stata effettuata troppe volte. Riprova pi\xF9 tardi"
  },
  ["image" /* Slider */]: {
    "\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE": "Per la sicurezza del tuo account, trascina il cursore qui sotto per completare il pezzo del puzzle.",
    "\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01": "Fantastico! Tempo impiegato {value} secondi!",
    \u6CA1\u6709\u5BF9\u51C6\u5462: "Non allineato",
    "\u6709\u70B9\u96BE\u5462\uFF0C\u5DF2\u66F4\u6362\u9898\u76EE": "\xC8 un po' complicato. Il tema \xE8 stato cambiato.",
    \u64CD\u4F5C\u6B65\u9AA4: "Passi",
    "\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904": "1.Tieni premuto il cursore e fallo scorrere verso destra finch\xE9 il pezzo del puzzle non \xE8 allineato.",
    "\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1": "2. Rilascia il dito e completa la verifica.",
    \u5C1D\u8BD5\u592A\u591A\u4E86: "Troppi tentativi",
    xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801: "Il codice di verifica verr\xE0 automaticamente aggiornato dopo {value} secondi",
    "\u7F51\u7EDC\u5F02\u5E38, \u8BF7\u5237\u65B0": "Errore di rete. Si prega di aggiornare la pagina.",
    \u52A0\u8F7D\u4E2D: "Caricamento in corso"
  },
  ["sms" /* SMS */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Inserisci il codice di verifica",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Il codice di verifica SMS sar\xE0 inviato a",
    \u91CD\u65B0\u53D1\u9001: "Invia di nuovo",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Reinvia dopo",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Inserisci il codice di verifica corretto"
  },
  ["email" /* Email */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Inserisci il codice di verifica",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Invieremo il codice di verifica al tuo indirizzo e-mail",
    \u91CD\u65B0\u53D1\u9001: "Invia di nuovo",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Reinvia dopo",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Inserisci il codice di verifica corretto"
  },
  ["sms_email" /* SMSWithEmail */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Inserisci il codice di verifica",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Il codice di verifica SMS sar\xE0 inviato a",
    \u91CD\u65B0\u53D1\u9001: "Invia di nuovo",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Reinvia dopo",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Inserisci il codice di verifica corretto",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Invieremo il codice di verifica al tuo indirizzo e-mail",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Passa alla verifica via SMS",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Passa alla verifica via e-mail"
  },
  ["birthday" /* DateOfBirth */]: {
    \u8EAB\u4EFD\u9A8C\u8BC1: "Verifica dell'identit\xE0",
    "\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)": "Data di nascita (GG/MM/AAAA)",
    \u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F: "Inserisci la data di nascita corretta",
    \u63D0\u4EA4: "Invia"
  }
};

// src/locales/pl.ts
var locales6 = {
  global: {
    \u5B89\u5168\u6821\u9A8C: "Weryfikacja bezpiecze\u0144stwa",
    "\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD": "Twoje konto jest bardzo cenne. Aby chroni\u0107 bezpiecze\u0144stwo Twojego konta, musimy zweryfikowa\u0107 Twoj\u0105 to\u017Csamo\u015B\u0107.",
    \u6ED1\u5757\u9A8C\u8BC1: "Weryfikacja poprzez suwak",
    \u77ED\u4FE1\u9A8C\u8BC1: "Weryfikacja SMS",
    \u90AE\u7BB1\u9A8C\u8BC1: "Weryfikacja e-mail",
    \u51FA\u751F\u65E5\u671F\u9A8C\u8BC1: "Weryfikacja daty urodzenia",
    "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5": "Zbyt cz\u0119ste pr\xF3by. Prosimy spr\xF3bowa\u0107 ponownie p\xF3\u017Aniej"
  },
  ["image" /* Slider */]: {
    "\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE": "Dla bezpiecze\u0144stwa twojego konta, przeci\u0105gnij suwak poni\u017Cej, aby doko\u0144czy\u0107 uk\u0142adank\u0119.",
    "\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01": "\u015Awietnie! Czas: {value} sekund!",
    \u6CA1\u6709\u5BF9\u51C6\u5462: "Nie jest r\xF3wno.",
    "\u6709\u70B9\u96BE\u5462\uFF0C\u5DF2\u66F4\u6362\u9898\u76EE": "To jest troch\u0119 trudne. Temat zosta\u0142 zmieniony.",
    \u64CD\u4F5C\u6B65\u9AA4: "Kroki",
    "\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904": "1. Przytrzymaj suwak i przesu\u0144 go w prawo, a\u017C elementy si\u0119 wyr\xF3wnaj\u0105.",
    "\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1": "2. Pu\u015B\u0107 suwak i zako\u0144cz weryfikacj\u0119.",
    \u5C1D\u8BD5\u592A\u591A\u4E86: "Zbyt wiele pr\xF3b",
    xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801: "Kod weryfikacyjny zostanie automatycznie od\u015Bwie\u017Cony po {value} sekundach.",
    "\u7F51\u7EDC\u5F02\u5E38, \u8BF7\u5237\u65B0": "Nieprawid\u0142owo\u015Bci w sieci. Prosz\u0119 od\u015Bwie\u017Cy\u0107.",
    \u52A0\u8F7D\u4E2D: "\u0141adowanie"
  },
  ["sms" /* SMS */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Wprowad\u017A kod weryfikacyjny.",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Kod weryfikacyjny SMS-em zostanie wys\u0142any na",
    \u91CD\u65B0\u53D1\u9001: "Wy\u015Blij ponownie",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Wy\u015Blij ponownie po",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Prosz\u0119 wprowadzi\u0107 poprawny kod weryfikacyjny",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Prze\u0142\u0105cz na weryfikacj\u0119 SMS",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Prze\u0142\u0105cz na weryfikacj\u0119 e-mail"
  },
  ["email" /* Email */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Wprowad\u017A kod weryfikacyjny.",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Wy\u015Blemy kod weryfikacyjny na Tw\xF3j adres e-mail.",
    \u91CD\u65B0\u53D1\u9001: "Wy\u015Blij ponownie",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Wy\u015Blij ponownie po",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Prosz\u0119 wprowadzi\u0107 poprawny kod weryfikacyjny",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Prze\u0142\u0105cz na weryfikacj\u0119 SMS",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Prze\u0142\u0105cz na weryfikacj\u0119 e-mail"
  },
  ["sms_email" /* SMSWithEmail */]: {
    \u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801: "Wprowad\u017A kod weryfikacyjny.",
    \u77ED\u4FE1\u5C06\u53D1\u9001\u81F3: "Kod weryfikacyjny SMS-em zostanie wys\u0142any na",
    \u91CD\u65B0\u53D1\u9001: "Wy\u015Blij ponownie",
    x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6: "Wy\u015Blij ponownie po",
    \u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801: "Prosz\u0119 wprowadzi\u0107 poprawny kod weryfikacyjny",
    \u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1: "Wy\u015Blemy kod weryfikacyjny na Tw\xF3j adres e-mail.",
    \u5207\u6362\u5230\u77ED\u4FE1\u9A8C\u8BC1: "Prze\u0142\u0105cz na weryfikacj\u0119 SMS",
    \u5207\u6362\u5230\u90AE\u7BB1\u9A8C\u8BC1: "Prze\u0142\u0105cz na weryfikacj\u0119 e-mail"
  },
  ["birthday" /* DateOfBirth */]: {
    \u8EAB\u4EFD\u9A8C\u8BC1: "weryfikacja to\u017Csamo\u015Bci",
    "\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)": "Data urodzenia (DD/MM/RR)",
    \u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F: "Podaj poprawn\u0105 dat\u0119 urodzenia",
    \u63D0\u4EA4: "Wy\u015Blij"
  }
};

// src/components/withTranslation.tsx
var LOCALE_MAP = {
  en: locales,
  de: locales2,
  es: locales3,
  fr: locales4,
  it: locales5,
  pl: locales6
};
function getDisplayName(Component) {
  if (typeof Component === "string") {
    return Component.length > 0 ? Component : "Unknown";
  }
  return Component.displayName || Component.name;
}
var ObjectRe = /\{(.+?)\}/g;
function withTranslation(componentName) {
  return (WrappedCompnent) => {
    var _a;
    return _a = class extends React.Component {
      constructor() {
        super(...arguments);
        __publicField(this, "getLocale", () => {
          const localeCode = this.getLocaleCode();
          const locales7 = LOCALE_MAP[localeCode] || locales;
          const localeObj = locales7[componentName || "global"] || {};
          return __spreadValues(__spreadValues({}, locales7.global), localeObj);
        });
        __publicField(this, "getLocaleCode", () => {
          return this.props.locale || "en";
        });
        __publicField(this, "translate", (key, values) => {
          const locales7 = this.getLocale();
          const text = locales7[key] || key;
          if (!values) {
            return text;
          }
          return text.replace(ObjectRe, (original, matched) => {
            const value = values[matched];
            if (typeof value !== "undefined") {
              return value;
            }
            return original;
          });
        });
      }
      render() {
        const props = {
          t: this.translate,
          localeCode: this.getLocaleCode()
        };
        return /* @__PURE__ */ React.createElement(WrappedCompnent, __spreadValues(__spreadValues({}, props), this.props));
      }
    }, __publicField(_a, "displayName", `withTranslation${getDisplayName(WrappedCompnent)}`), _a;
  };
}

// src/utils/noop.ts
function noop() {
}

// src/components/toast/index.ts
var defaultToast = {
  show: noop
};
var toast = __spreadValues({}, defaultToast);
var Toast = typeof window !== "undefined" ? toast : defaultToast;
function set(toastConfig) {
  Toast = toastConfig;
}

// src/verifyHOC.tsx
import React21, { useEffect as useEffect12, useRef as useRef12, useState as useState10 } from "react";
import cookie from "js-cookie";

// src/context.tsx
import React2 from "react";
var AppContext = React2.createContext(null);

// src/utils/http.ts
import axios from "axios";
var Http = class {
  constructor(options) {
    __publicField(this, "inst");
    this.inst = axios.create(__spreadValues({
      timeout: 60 * 1e3,
      headers: {
        "Content-Type": "application/json"
      },
      withCredentials: true
    }, options));
  }
  fetchVerifications(data, url, options) {
    return __async(this, null, function* () {
      const resp = yield this.inst.post(url || "/risk-security/public/obtain/check/securityGetStrategy", __spreadValues({}, data), options);
      return resp.data;
    });
  }
  validate(data, options) {
    return __async(this, null, function* () {
      const resp = yield this.inst.post("/risk-security/public/obtain/check/securityCheckStrategy", data, options);
      return resp.data;
    });
  }
  getComponentDetail(data, options) {
    return __async(this, null, function* () {
      const resp = yield this.inst.post("/risk-security/public/components/getComponents", data, options);
      return resp.data;
    });
  }
};

// src/utils/transform-status.ts
var STATUS_MAP = {
  1: "pending" /* Pending */,
  0: "pass" /* Pass */,
  90: "rejected" /* Rejected */,
  2: "unknown" /* Unknown */
};
var transformStatus = (s) => {
  const status = STATUS_MAP[s];
  return status;
};

// src/components/distributor/index.tsx
import React18 from "react";

// src/hooks/use-app.ts
import React3 from "react";
function useApp() {
  return React3.useContext(AppContext);
}

// src/components/sms/index.tsx
import React8, { useCallback as useCallback2, useEffect as useEffect4, useRef as useRef3, useState as useState2 } from "react";

// src/constants.ts
var INITIAL_COUNTDOWN = 60;
var LAST_COUNTDOWN = 0;
var INTERVAL = 1e3;

// src/hooks/use-interval.ts
import { useEffect as useEffect2, useRef } from "react";

// src/hooks/use-isomorphic-layout-effect.ts
import { useEffect, useLayoutEffect } from "react";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

// src/hooks/use-interval.ts
function useInterval(callback, delay) {
  const savedCallback = useRef(callback);
  const id = useRef();
  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect2(() => {
    if (!delay && delay !== 0) {
      return;
    }
    id.current = window.setInterval(() => savedCallback.current(), delay);
    return () => clearInterval(id.current);
  }, [delay]);
  return id.current;
}

// src/components/verify-code/index.tsx
import React7, { forwardRef as forwardRef2, useCallback } from "react";
import { verifyCode as styles3 } from "@al/eu-security-verify-style";

// src/components/input/index.tsx
import React4, {
  forwardRef,
  useEffect as useEffect3,
  useImperativeHandle,
  useRef as useRef2,
  useState
} from "react";
import classNames from "classnames";
import { input } from "@al/eu-security-verify-style";

// src/utils/bound.ts
function bound(position, min, max) {
  let result = position;
  if (min !== void 0) {
    result = Math.max(position, min);
  }
  if (max !== void 0) {
    result = Math.min(result, max);
  }
  return result;
}

// src/utils/with-default-props.ts
import assign from "lodash/assign";
import assignWith from "lodash/assignWith";
import isUndefined from "lodash/isUndefined";
function mergeProps(...items) {
  function customizer(objValue, srcValue) {
    return isUndefined(srcValue) ? objValue : srcValue;
  }
  let ret = assign({}, items[0]);
  for (let i = 1; i < items.length; i++) {
    ret = assignWith(ret, items[i], customizer);
  }
  return ret;
}

// src/components/input/index.tsx
var defaultProps = {
  type: "text",
  defaultValue: "",
  length: 5,
  plain: true,
  error: false,
  seperated: true,
  caret: true
};
var Input = forwardRef(function Input2(p, ref) {
  var _a;
  const props = mergeProps(defaultProps, p);
  const cellLength = props.length > 0 && props.length < Infinity ? Math.floor(props.length) : defaultProps.length;
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState((_a = props.value) != null ? _a : props.defaultValue);
  useEffect3(() => {
    var _a2;
    setValue((_a2 = props.value) != null ? _a2 : props.defaultValue);
  }, [props.value, props.defaultValue]);
  const rootRef = useRef2(null);
  const nativeInputRef = useRef2(null);
  useEffect3(() => {
    var _a2;
    if (value.length >= cellLength) {
      (_a2 = props.onFill) == null ? void 0 : _a2.call(props, value);
    }
  }, [value, cellLength]);
  const onFocus = () => {
    var _a2, _b;
    (_a2 = nativeInputRef.current) == null ? void 0 : _a2.focus();
    setFocused(true);
    (_b = props.onFocus) == null ? void 0 : _b.call(props);
  };
  const onBlur = () => {
    var _a2;
    setFocused(false);
    (_a2 = props.onBlur) == null ? void 0 : _a2.call(props);
  };
  useImperativeHandle(ref, () => ({
    focus: () => {
      var _a2;
      (_a2 = rootRef.current) == null ? void 0 : _a2.focus();
    },
    blur: () => {
      var _a2, _b;
      (_a2 = rootRef.current) == null ? void 0 : _a2.blur();
      (_b = nativeInputRef.current) == null ? void 0 : _b.blur();
    },
    clear: () => {
      if (nativeInputRef.current) {
        nativeInputRef.current.value = "";
      }
      setValue("");
    }
  }));
  const renderCells = () => {
    const cells = [];
    const chars = value.split("");
    const caretIndex = chars.length;
    const focusedIndex = bound(chars.length, 0, cellLength - 1);
    for (let i = 0; i < cellLength; i++) {
      cells.push(/* @__PURE__ */ React4.createElement("div", {
        className: classNames(input.cell, {
          [input.cellWithCaret]: props.caret && caretIndex === i && focused,
          [input.cellFocused]: focusedIndex === i && focused,
          [input.cellWithDot]: !props.plain && chars[i]
        }),
        key: i
      }, chars[i] && props.plain ? chars[i] : ""));
    }
    return cells;
  };
  const cls = classNames(input.inputContainer, {
    [input.containerFocused]: focused,
    [input.containerError]: props.error,
    [input.seperated]: props.seperated
  });
  return /* @__PURE__ */ React4.createElement("div", {
    ref: rootRef,
    tabIndex: 0,
    className: cls,
    onFocus,
    onBlur
  }, /* @__PURE__ */ React4.createElement("div", {
    className: input.cellContainer
  }, renderCells()), /* @__PURE__ */ React4.createElement("input", {
    ref: nativeInputRef,
    value,
    className: input.nativeInput,
    type: props.type,
    pattern: "[0-9]*",
    inputMode: "numeric",
    onChange: (e) => {
      if (props.type === "number" && isNaN(Number(e.target.value))) {
        return;
      }
      setValue(e.target.value.slice(0, props.length));
    }
  }));
});

// src/components/security-prompt/index.tsx
import React5 from "react";
import { securityPrompt as styles } from "@al/eu-security-verify-style";
var SecurityPromptImpl = (props) => {
  return /* @__PURE__ */ React5.createElement("div", {
    className: styles.prompt
  }, props.t("\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD"));
};
var SecurityPrompt = withTranslation("SecurityPrompt")(SecurityPromptImpl);

// src/components/title/index.tsx
import React6 from "react";
import { title as styles2 } from "@al/eu-security-verify-style";
var Title = (props) => {
  return /* @__PURE__ */ React6.createElement("div", {
    className: styles2.title
  }, props.title);
};

// src/components/verify-code/index.tsx
var VerifyCode = forwardRef2(function VerifyCode2(props, ref) {
  const { t, onFill } = props;
  const onCodeFill = useCallback((value) => {
    onFill == null ? void 0 : onFill(value);
  }, [onFill]);
  return /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(Title, {
    title: props.title
  }), /* @__PURE__ */ React7.createElement("div", {
    className: styles3.subTitle
  }, props.sendToText), /* @__PURE__ */ React7.createElement("div", {
    className: styles3.contact
  }, props.contact), /* @__PURE__ */ React7.createElement("div", {
    className: styles3.verifyWrap
  }, /* @__PURE__ */ React7.createElement(Input, {
    ref,
    onFill: onCodeFill
  }), /* @__PURE__ */ React7.createElement("div", {
    className: styles3.actions
  }, props.countdown > 0 ? /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement("span", null, t("x\u79D2\u540E\u91CD\u65B0\u83B7\u53D6")), " (", /* @__PURE__ */ React7.createElement("span", {
    className: styles3.countdown
  }, props.countdown, props.locale === "es" ? "seg" : "s"), ")") : /* @__PURE__ */ React7.createElement("span", {
    className: styles3.resend,
    onClick: props.onResend
  }, `${t("\u91CD\u65B0\u53D1\u9001")} >>`), /* @__PURE__ */ React7.createElement("span", {
    className: styles3.switcher,
    onClick: props.onClickSwitcher
  }, props.switcher))), /* @__PURE__ */ React7.createElement(SecurityPrompt, {
    locale: props.locale
  }));
});

// src/components/sms/index.tsx
var SMSVerifyImpl = (props) => {
  var _a;
  const { t, validate, onNext } = props;
  const app = useApp();
  const [delay, setDelay] = useState2(null);
  const [countdown, setCountdown] = useState2(INITIAL_COUNTDOWN);
  const smsRef = useRef3(null);
  const sending = useRef3(false);
  const submitting = useRef3(false);
  const contact = ((_a = app == null ? void 0 : app.strategyData) == null ? void 0 : _a.helpText.enPhone) || props.phone || "";
  useInterval(() => {
    if (countdown > LAST_COUNTDOWN) {
      setCountdown(countdown - 1);
    } else {
      setDelay(null);
    }
  }, delay);
  const submit = useCallback2((val) => __async(void 0, null, function* () {
    if (submitting.current) {
      return;
    }
    try {
      submitting.current = true;
      const result = yield validate({
        method: "sms" /* SMS */,
        value: val
      });
      onNext("sms" /* SMS */, result, t("\u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801"), {
        fail: () => {
          var _a2;
          (_a2 = smsRef.current) == null ? void 0 : _a2.clear();
        }
      });
    } catch (error) {
    } finally {
      submitting.current = false;
    }
  }), [validate, onNext, t]);
  const onResend = () => {
    sendSms();
  };
  const onFill = useCallback2((val) => {
    submit(val);
  }, [submit]);
  const startCountdown = useRef3(() => {
    setCountdown(INITIAL_COUNTDOWN);
  });
  const sendSms = () => __async(void 0, null, function* () {
    var _a2;
    if (sending.current) {
      return;
    }
    try {
      sending.current = true;
      const resp = yield app == null ? void 0 : app.http.getComponentDetail({
        operationId: ((_a2 = app.strategyData) == null ? void 0 : _a2.operationId) || "",
        type: props.bizType,
        method: "sms" /* SMS */,
        email: app == null ? void 0 : app.email
      });
      if (resp == null ? void 0 : resp.success) {
        startCountdown.current();
      } else {
        Toast.show(resp == null ? void 0 : resp.errMsg);
      }
    } catch (error) {
    } finally {
      sending.current = false;
    }
  });
  useEffect4(() => {
    setDelay(INTERVAL);
  }, [countdown]);
  useEffect4(() => {
    sendSms();
  }, []);
  return /* @__PURE__ */ React8.createElement(VerifyCode, {
    ref: smsRef,
    t,
    title: t("\u77ED\u4FE1\u9A8C\u8BC1"),
    locale: props.locale,
    contact,
    sendToText: t("\u77ED\u4FE1\u5C06\u53D1\u9001\u81F3"),
    countdown,
    onResend,
    onFill
  });
};
var SMSVerify = withTranslation("sms" /* SMS */)(SMSVerifyImpl);

// src/components/email/index.tsx
import React9, { useCallback as useCallback3, useEffect as useEffect5, useRef as useRef4, useState as useState3 } from "react";
var EmailVerifyImpl = (props) => {
  var _a;
  const { t, validate, onNext } = props;
  const app = useApp();
  const [delay, setDelay] = useState3(null);
  const [countdown, setCountdown] = useState3(INITIAL_COUNTDOWN);
  const emailRef = useRef4(null);
  const sending = useRef4(false);
  const submitting = useRef4(false);
  useInterval(() => {
    if (countdown > LAST_COUNTDOWN) {
      setCountdown(countdown - 1);
    } else {
      setDelay(null);
    }
  }, delay);
  const startCountdown = useRef4(() => {
    setCountdown(INITIAL_COUNTDOWN);
  });
  const submit = useCallback3((val) => __async(void 0, null, function* () {
    if (submitting.current) {
      return;
    }
    try {
      submitting.current = true;
      const result = yield validate({
        method: "email" /* Email */,
        value: val
      });
      onNext("email" /* Email */, result, t("\u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801"), {
        fail: () => {
          var _a2;
          (_a2 = emailRef.current) == null ? void 0 : _a2.clear();
        }
      });
    } catch (error) {
    } finally {
      submitting.current = false;
    }
  }), [validate, onNext, t]);
  const onResend = () => {
    sendEmail();
  };
  const onFill = useCallback3((val) => {
    submit(val);
  }, [submit]);
  const sendEmail = () => __async(void 0, null, function* () {
    var _a2;
    if (sending.current) {
      return;
    }
    try {
      sending.current = true;
      const resp = yield app == null ? void 0 : app.http.getComponentDetail({
        operationId: ((_a2 = app.strategyData) == null ? void 0 : _a2.operationId) || "",
        type: props.bizType,
        method: "email" /* Email */,
        email: app == null ? void 0 : app.email
      });
      if (resp == null ? void 0 : resp.success) {
        startCountdown.current();
      } else {
        Toast.show(resp == null ? void 0 : resp.errMsg);
      }
    } catch (error) {
    } finally {
      sending.current = false;
    }
  });
  useEffect5(() => {
    setDelay(INTERVAL);
  }, [countdown]);
  useEffect5(() => {
    sendEmail();
  }, []);
  return /* @__PURE__ */ React9.createElement(VerifyCode, {
    ref: emailRef,
    title: t("\u90AE\u7BB1\u9A8C\u8BC1"),
    t,
    locale: props.locale,
    contact: ((_a = app == null ? void 0 : app.strategyData) == null ? void 0 : _a.helpText.enEmail) || props.email || "",
    sendToText: t("\u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1"),
    countdown,
    onResend,
    onFill
  });
};
var EmailVerify = withTranslation("email" /* Email */)(EmailVerifyImpl);

// src/components/slider/index.tsx
import React13, { useCallback as useCallback4, useEffect as useEffect9, useRef as useRef8, useState as useState6 } from "react";
import classNames2 from "classnames";
import { slider as styles4 } from "@al/eu-security-verify-style";

// src/hooks/use-timeout.ts
import { useEffect as useEffect6, useRef as useRef5 } from "react";
function useTimeout(callback, delay) {
  const savedCallback = useRef5(callback);
  const id = useRef5();
  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect6(() => {
    if (!delay && delay !== 0) {
      return;
    }
    const id2 = setTimeout(() => savedCallback.current(), delay);
    return () => clearTimeout(id2);
  }, [delay]);
  return id.current;
}

// src/components/slider/components/slider/index.tsx
import React11, { useEffect as useEffect7, useRef as useRef7, useState as useState4 } from "react";

// src/components/slider/components/slider/thumb.tsx
import React10, { useRef as useRef6 } from "react";
import { useDrag } from "@use-gesture/react";

// src/components/slider/images/arrow.png
var arrow_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAzCAYAAAAtg6DjAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMPSURBVHgB3ZlNbhpBEIWrZkZylj4CR0CxHWUJliJYxicwnMBwgsAJICfw+ARkF1AWsA5GcINwBHZJJHClugEH5OmeH2Z6evg2I9OtgefurnpdhWAQuqk9wAt05B8IPj6P2mAABEPQ+3oDHHg8/hS/wfp3ExeTFWSIA6ZAqLz9kD6DdzGmcr0EGWJS5FIxUAYXMhVqTuT6T59XbhE4hlDKUqgxkfLcrf9WgeApeAIL9WhON5/KkDLGAs8hdFXrA+KDYnQFDrbw5/AJUsLcdj0AZ6MWP7qK0UtOMz5d11qQErmIFODzsANKoXJGj67rXyCN74KcCc6fR3T4H9KFE8hdpEAGG3LGcqsGIdzRdNiEhFghUiDTB6cRGWWDmXAaukvijqwRKQgVSmwoNlDFxXAJMbBKpCALodaJFFC5cik8rbR8gRPiCbVS5B66qvv8C+8VoyvAlypOfyzC3pNbnowCzoYN0JkGcuf0oX4f9h6rRQpCTYN0R3rTYPV2PYSFdPihE6M0DYURKUjqjgolUpDEHRVOpCDcHfHlnO+ue3f0KpI+ZltnSZ21EEgD5Yoe5FKkMi+/6w40nrG47IR64DniIJfgHJElFXh0lNbpfKgIMzCB82biAG7acu+eI0LXGprnG11lGsE7GV2hgIRnBJpznrzd50kPCsZWoCOMgCo/+lzyPHI81t9CDpHXKs+dc2FaIRD7fD17U/AqjMhdb9PXTOni7Htgv7MQZ3J3X+xoZrS5odtXjVp/Jrld0ONHcMuAZN+kjdORr3uHtSspi1nuux7/wkbwBBa44RrPIrzGY+VK/q/WgaZah0LgEiJgncjXuyKkV3e1KrpGuAzPk1TQrRG5TfLaXsh462LiCRRYsV05RVQ4kAz0LiZ5Vyv3ldwVh8dKFyOTfHKBglxFyiQf5mK2xeWTyC1Pnupi4pDLmUzDxcTB6Eqm6WLiYGwlI7iYX+xibqO6mDiYCzzORUPTVGWBkCgHRvpqMAWqSp/SxWQmUGBOJAWWPhO7mDiYDTyix0iiPU6XvLJf08iBUfgHkCJUtkqtq34AAAAASUVORK5CYII=";

// src/components/slider/components/slider/thumb.tsx
var Thumb = (props) => {
  const { value, min, max, disabled, styles: styles7, onDrag } = props;
  const prevValue = useRef6(value);
  const currentPosition = () => {
    return {
      left: `${value}px`,
      right: "auto"
    };
  };
  const bind = useDrag((state) => {
    var _a;
    if (disabled) {
      return;
    }
    if (state.first) {
      prevValue.current = value;
    }
    const x = state.xy[0] - state.initial[0];
    const sliderOffsetWidth = (_a = props.trackRef.current) == null ? void 0 : _a.offsetWidth;
    if (!sliderOffsetWidth) {
      return;
    }
    onDrag(prevValue.current + x, state.first, state.last, state.elapsedTime);
  }, {
    axis: "x",
    pointer: {
      touch: true
    }
  });
  return /* @__PURE__ */ React10.createElement("div", __spreadValues({
    className: styles7.thumbContainer,
    style: currentPosition()
  }, bind()), /* @__PURE__ */ React10.createElement("div", {
    className: styles7.thumb
  }, /* @__PURE__ */ React10.createElement("img", {
    className: styles7.thumbImg,
    src: arrow_default
  })));
};

// src/components/slider/components/slider/index.tsx
var Slider = (props) => {
  const { min, max, disabled, styles: styles7, onChange, onAfterChange } = props;
  const sliderRef = useRef7(null);
  const trackRef = useRef7(null);
  const [rawValue, setRawValue] = useState4(props.value);
  const dragLockRef = useRef7(0);
  const valueBeforeDragRef = useRef7();
  const fillSize = `${rawValue}px`;
  useEffect7(() => {
    setRawValue(props.value);
  }, [props.value]);
  function getValueByPosition(position) {
    const newPosition = position < min ? min : position > max ? max : position;
    return newPosition;
  }
  const renderThumb = () => {
    return /* @__PURE__ */ React11.createElement(Thumb, {
      value: rawValue,
      min,
      max,
      disabled,
      trackRef,
      styles: styles7,
      onDrag: (position, first, last, elapsedTime) => {
        if (first) {
          dragLockRef.current += 1;
          valueBeforeDragRef.current = rawValue;
        }
        const val = getValueByPosition(position);
        const valueBeforeDrag = valueBeforeDragRef.current;
        if (!valueBeforeDrag)
          return;
        const next = val;
        setRawValue(next);
        onChange == null ? void 0 : onChange(next);
        if (last) {
          onAfterChange == null ? void 0 : onAfterChange(next, elapsedTime);
          window.setTimeout(() => {
            dragLockRef.current -= 1;
          }, 100);
        }
      }
    });
  };
  return /* @__PURE__ */ React11.createElement("div", {
    ref: sliderRef,
    className: styles7.slider
  }, /* @__PURE__ */ React11.createElement("div", {
    ref: trackRef,
    className: styles7.track
  }, /* @__PURE__ */ React11.createElement("div", {
    className: styles7.fill,
    style: {
      width: fillSize
    }
  }), renderThumb()));
};

// src/components/slider/components/too-frequently/index.tsx
import React12, { useEffect as useEffect8, useState as useState5 } from "react";

// src/images/timer.png
var timer_default = "data:image/png;base64,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";

// src/components/slider/components/too-frequently/index.tsx
var TooFrequently = (props) => {
  const { t, styles: styles7 } = props;
  const [countdown, setCountdown] = useState5(5);
  const id = useInterval(() => {
    if (countdown > 0) {
      setCountdown(countdown - 1);
    } else {
      clearInterval(id);
      props.onRefresh();
    }
  }, 1e3);
  useEffect8(() => {
    return () => {
      if (id) {
        clearInterval(id);
      }
    };
  }, []);
  return /* @__PURE__ */ React12.createElement("div", {
    className: styles7.tooFrequently
  }, /* @__PURE__ */ React12.createElement("img", {
    className: styles7.frequentImg,
    src: timer_default
  }), /* @__PURE__ */ React12.createElement("p", {
    className: styles7.frequentText
  }, t("\u5C1D\u8BD5\u592A\u591A\u4E86")), /* @__PURE__ */ React12.createElement("p", {
    className: styles7.countdownText
  }, t("xS\u540E\u81EA\u52A8\u4E3A\u60A8\u5237\u65B0\u9A8C\u8BC1\u7801", {
    value: `${countdown}`
  })));
};

// src/components/slider/images/successful.png
var successful_default = "data:image/png;base64,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";

// src/components/slider/images/refresh.png
var refresh_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUdwTLKysrOzs7KysrKysrCwsLKysrKysrOzs7CwsLOzs7KysrKysrOzs7Ozs7KysrOzs7KysrKysrGxsbKysrOzs25BfXcAAAAVdFJOUwBg749AEID+3yDPML+fr5ZvcO5QvnMAECoAAAHdSURBVHjapZZbloQgDERBnhHkaCv73+oMAoPdCDaZ+hQvFWISIW0JMJxzENWCMaQnwZnVPmmyjF8XrfesjXI7+U+5Pa9S770yDVMZyUqaxgPIAPNbdo1oA+/CZi6vTvOySLm46xk0tOG15GiFy5bU5QUlG7BY8v6y+jxAc/LZLSzm5ErJrf7wAlcsE6QhYA04s1N62jOvYZaz2ZLhv6K3sHxibaTuYHhid9+G9QNLtjYcj7L32ky/wfoS9LnCSE+wyqJVXIxT0CidxhRDZmOCk4vGOPkgwLE8sA5pzJBRl6o1SHgKnYhkRTC2SBhw+RJ0z8lehi11gCIsh8g8+c1/YE4MKuwlwoCCXYAhfqoZU1lKxG6eMJX1CpsgmsoE5siNsSHmB8tVYhH54qHQzs4QwyWtSk/K4ahdGSV6dNwqWvLuN+S4lX7o1HA1JuIVaDY09DS8/wP5QNDBOGs+A4fvgv7Mr1ExlG9ZBfXPW8OXrKy6O9PPLLu/wmnaY/fJB82C3NOeNc0F84Wt6a75Fm1VYuudMw7NK7xaWpUolU9y1FzStFmfpNZeNpXPmqwLl/Vljp4xZNMvvozXUq/1sQwSXqNSfFX6TqlP8uADFxV2vFSSPhgXZFACOOcGOtwPBZg+XTmF2/IAAAAASUVORK5CYII=";

// src/components/slider/index.tsx
var MAX_REFRESH_OR_FAIL = 5;
var INITIAL_FILLING_POSITION = 18;
var SliderImpl = (props) => {
  const { t } = props;
  const app = useApp();
  const http = app == null ? void 0 : app.http;
  const [validateResult, setValidateResult] = useState6();
  const [captchaData, setCaptchaData] = useState6(null);
  const [captchaStatus, setCaptchaStatus] = useState6(0 /* Normal */);
  const [puzzleLoading, setPuzzleLoading] = useState6(true);
  const [puzzleResolved, setPuzzleResolved] = useState6(false);
  const [duration, setDuration] = useState6("0");
  const [fillingStyles, setFillingStyles] = useState6({
    width: 0,
    height: 0,
    top: 0
  });
  const [fillingPosition, setFillingPosition] = useState6(INITIAL_FILLING_POSITION);
  const [errorText, setErrorText] = useState6("");
  const backImage = useRef8(new Image());
  const [backImageLoaded, setBackImageLoaded] = useState6(false);
  const fillingImage = useRef8(new Image());
  const [fillingImageLoaded, setFillingImageLoaded] = useState6(false);
  const [imageRatio, setImageRatio] = useState6({
    width: 0,
    height: 0
  });
  const [fillingDimensions, setFillingDimensions] = useState6({
    width: 0,
    height: 0
  });
  const [puzzleDimensions, setPuzzleDimensions] = useState6({
    width: 0,
    height: 0
  });
  const [successDelay, setSuccessDelay] = useState6(null);
  const successTimer = useTimeout(() => {
    props.onNext("image" /* Slider */, validateResult);
  }, successDelay);
  const puzzleRef = useRef8(null);
  const requestingCaptcha = useRef8(false);
  const validating = useRef8(false);
  const setPuzzleDimension = useCallback4(() => {
    if (puzzleRef.current) {
      setPuzzleDimensions({
        width: puzzleRef.current.offsetWidth,
        height: puzzleRef.current.offsetHeight
      });
    }
  }, []);
  const onBackImgLoad = () => {
    setBackImageLoaded(true);
    setPuzzleLoading(false);
  };
  const onFillingImgLoad = () => {
    setFillingImageLoaded(true);
  };
  const onRefresh = () => {
    fetchCaptchaInfo();
  };
  const onSliderMove = (value) => {
    setFillingPosition(value);
  };
  const onFinishSlide = (value, elapsedTime) => {
    setDuration(`${(elapsedTime / 1e3).toFixed(1)}`);
    setFillingPosition(value);
    validateCaptcha(value);
  };
  const validateCaptcha = (value) => __async(void 0, null, function* () {
    var _a, _b, _c;
    if (validating.current) {
      return;
    }
    validating.current = true;
    const moveLength = Math.floor(value / imageRatio.width);
    try {
      const result = yield props.validate({
        method: "image" /* Slider */,
        value: `${moveLength}`
      });
      setValidateResult(result);
      if (result == null ? void 0 : result.success) {
        const component = (_b = (_a = result == null ? void 0 : result.data) == null ? void 0 : _a.validComponents) == null ? void 0 : _b.find((c) => c.method === "image" /* Slider */);
        const validateStatus = transformStatus((_c = component == null ? void 0 : component.status) != null ? _c : 1);
        if (validateStatus === "pass" /* Pass */) {
          setPuzzleResolved(true);
          setSuccessDelay(1e3);
        } else if (validateStatus === "rejected" /* Rejected */) {
          setFillingPosition(INITIAL_FILLING_POSITION);
          const count = (component == null ? void 0 : component.rejectCnt) || 0;
          if (count < MAX_REFRESH_OR_FAIL) {
            setErrorText(t("\u6CA1\u6709\u5BF9\u51C6\u5462"));
          } else {
            setErrorText("");
            setCaptchaStatus(1 /* TooFrequently */);
          }
        }
      }
    } catch (error) {
    } finally {
      validating.current = false;
    }
  });
  const fetchCaptchaInfo = () => __async(void 0, null, function* () {
    var _a;
    if (requestingCaptcha.current) {
      return;
    }
    requestingCaptcha.current = true;
    try {
      const resp = yield http == null ? void 0 : http.getComponentDetail({
        operationId: ((_a = app == null ? void 0 : app.strategyData) == null ? void 0 : _a.operationId) || "",
        email: (app == null ? void 0 : app.email) || "",
        type: (app == null ? void 0 : app.bizType) || 0,
        method: "image" /* Slider */
      });
      if ((resp == null ? void 0 : resp.success) && resp.data) {
        setCaptchaStatus(0 /* Normal */);
        setCaptchaData(resp == null ? void 0 : resp.data);
        backImage.current.onload = onBackImgLoad;
        backImage.current.src = resp == null ? void 0 : resp.data.bigImageUrl;
        fillingImage.current.onload = onFillingImgLoad;
        fillingImage.current.src = resp == null ? void 0 : resp.data.smallImageUrl;
      } else {
        Toast.show(resp == null ? void 0 : resp.errMsg);
      }
    } catch (error) {
    } finally {
      requestingCaptcha.current = false;
    }
  });
  const renderPuzzle = () => {
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, puzzleResolved ? /* @__PURE__ */ React13.createElement("div", {
      className: styles4.resolved
    }, /* @__PURE__ */ React13.createElement("img", {
      className: styles4.resolvedImg,
      src: successful_default
    }), /* @__PURE__ */ React13.createElement("p", null, t("\u592A\u68D2\uFF01\u7528\u65F6xS\uFF01", { value: duration }))) : null, /* @__PURE__ */ React13.createElement("img", {
      className: styles4.backImg,
      src: captchaData == null ? void 0 : captchaData.bigImageUrl
    }), /* @__PURE__ */ React13.createElement("img", {
      className: styles4.fillingImg,
      src: captchaData == null ? void 0 : captchaData.smallImageUrl,
      style: __spreadProps(__spreadValues({}, fillingStyles), {
        transform: `translate(${fillingPosition}px)`
      })
    }));
  };
  const renderContent = () => {
    const maxPosition = puzzleDimensions.width - fillingStyles.width;
    switch (captchaStatus) {
      case 0 /* Normal */:
        return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(Title, {
          title: t("\u6ED1\u5757\u9A8C\u8BC1")
        }), /* @__PURE__ */ React13.createElement("div", {
          className: styles4.subTitle
        }, t("\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u62D6\u52A8\u4E0B\u65B9\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE")), /* @__PURE__ */ React13.createElement("div", {
          ref: puzzleRef,
          className: classNames2(styles4.puzzle, {
            [styles4.puzzleLoading]: puzzleLoading
          })
        }, puzzleLoading ? null : renderPuzzle()), /* @__PURE__ */ React13.createElement(Slider, {
          value: fillingPosition,
          min: INITIAL_FILLING_POSITION,
          max: maxPosition,
          styles: styles4,
          onAfterChange: onFinishSlide,
          onChange: onSliderMove
        }), /* @__PURE__ */ React13.createElement("div", {
          className: styles4.actions
        }, /* @__PURE__ */ React13.createElement("span", {
          className: styles4.error
        }, errorText), /* @__PURE__ */ React13.createElement("img", {
          className: styles4.refresh,
          src: refresh_default,
          onClick: onRefresh
        })), /* @__PURE__ */ React13.createElement("div", {
          className: styles4.hint
        }, /* @__PURE__ */ React13.createElement("ul", {
          className: styles4.steps
        }, /* @__PURE__ */ React13.createElement("li", null, t("\u6309\u4F4F\u6ED1\u5757\u4E0D\u653E\uFF0C\u5411\u53F3\u6ED1\u52A8\uFF0C\u76F4\u81F3\u62FC\u56FE\u5BF9\u51C6\u7F3A\u53E3\u5904")), /* @__PURE__ */ React13.createElement("li", {
          className: styles4.opStep
        }, t("\u677E\u5F00\u624B\u6307\uFF0C\u5B8C\u6210\u9A8C\u8BC1")))));
      case 1 /* TooFrequently */:
        return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(Title, {
          title: t("\u6ED1\u5757\u9A8C\u8BC1")
        }), /* @__PURE__ */ React13.createElement(TooFrequently, {
          t,
          styles: styles4,
          onRefresh
        }));
    }
  };
  useEffect9(() => {
    fetchCaptchaInfo();
    return () => {
      if (successTimer) {
        return clearTimeout(successTimer);
      }
    };
  }, []);
  useEffect9(() => {
    const width = backImage.current.width;
    const height = backImage.current.height;
    const widthRatio = puzzleDimensions.width / width;
    const heightRatio = puzzleDimensions.height / height;
    setImageRatio({
      width: widthRatio,
      height: heightRatio
    });
  }, [puzzleDimensions]);
  useEffect9(() => {
    if (backImageLoaded) {
      setPuzzleDimension();
    }
  }, [backImageLoaded, setPuzzleDimension]);
  useEffect9(() => {
    if (fillingImageLoaded) {
      setPuzzleDimension();
      const width = fillingImage.current.width;
      const height = fillingImage.current.height;
      setFillingDimensions({
        width,
        height
      });
    }
  }, [fillingImageLoaded, setPuzzleDimension]);
  useEffect9(() => {
    const scaledWidth = fillingDimensions.width * imageRatio.width;
    const scaledHeight = fillingDimensions.height * imageRatio.height;
    const scaledTop = Number((captchaData == null ? void 0 : captchaData.ylength) || 0) * imageRatio.height;
    setFillingStyles({
      width: scaledWidth,
      height: scaledHeight,
      top: scaledTop
    });
  }, [captchaData, fillingDimensions, imageRatio]);
  return /* @__PURE__ */ React13.createElement("div", {
    className: styles4.sliderCaptcha
  }, renderContent());
};
var SliderVerify = withTranslation("image" /* Slider */)(SliderImpl);

// src/components/sms-with-email/index.tsx
import React14, { useCallback as useCallback5, useEffect as useEffect10, useRef as useRef9, useState as useState7 } from "react";
var SMSWithEmailImpl = (props) => {
  var _a, _b;
  const { t, validate, onNext } = props;
  const app = useApp();
  const [method, setMethod] = useState7("email");
  const [smsCountdown, setSmsCountdown] = useState7(LAST_COUNTDOWN);
  const [emailCountdown, setEmailCountdown] = useState7(LAST_COUNTDOWN);
  const [smsDelay, setSmsDelay] = useState7(null);
  const [emailDelay, setEmailDelay] = useState7(null);
  const smsRef = useRef9(null);
  const emailRef = useRef9(null);
  const smsSending = useRef9(false);
  const emailSending = useRef9(false);
  const submitting = useRef9(false);
  const email = ((_a = app == null ? void 0 : app.strategyData) == null ? void 0 : _a.helpText.enEmail) || props.email || "";
  const phone = ((_b = app == null ? void 0 : app.strategyData) == null ? void 0 : _b.helpText.enPhone) || props.phone || "";
  useInterval(() => {
    if (smsCountdown > LAST_COUNTDOWN) {
      setSmsCountdown(smsCountdown - 1);
    } else {
      setSmsDelay(null);
    }
  }, smsDelay);
  useInterval(() => {
    if (emailCountdown > LAST_COUNTDOWN) {
      setEmailCountdown(emailCountdown - 1);
    } else {
      setEmailDelay(null);
    }
  }, emailDelay);
  const startEmailCountdown = useRef9(() => {
    setEmailCountdown(INITIAL_COUNTDOWN);
  });
  const startSmsCountdown = useRef9(() => {
    setSmsCountdown(INITIAL_COUNTDOWN);
  });
  const onSWitchToEmail = () => {
    var _a2;
    (_a2 = smsRef.current) == null ? void 0 : _a2.clear();
    if (emailCountdown === INITIAL_COUNTDOWN || emailCountdown === LAST_COUNTDOWN) {
      sendEmail();
    }
    setMethod("email");
  };
  const onSWitchToSMS = () => {
    var _a2;
    (_a2 = emailRef.current) == null ? void 0 : _a2.clear();
    if (smsCountdown === INITIAL_COUNTDOWN || smsCountdown === LAST_COUNTDOWN) {
      sendSms();
    }
    setMethod("sms");
  };
  const onResendSms = () => {
    sendSms();
  };
  const onResendEmail = () => {
    sendEmail();
  };
  const sendEmail = () => __async(void 0, null, function* () {
    var _a2;
    if (emailSending.current) {
      return;
    }
    try {
      emailSending.current = true;
      const resp = yield app == null ? void 0 : app.http.getComponentDetail({
        operationId: ((_a2 = app.strategyData) == null ? void 0 : _a2.operationId) || "",
        type: props.bizType,
        method: "email" /* Email */,
        email: app == null ? void 0 : app.email
      });
      if (resp == null ? void 0 : resp.success) {
        startEmailCountdown.current();
      } else {
        Toast.show(resp == null ? void 0 : resp.errMsg);
      }
    } catch (error) {
    } finally {
      emailSending.current = false;
    }
  });
  const sendSms = () => __async(void 0, null, function* () {
    var _a2;
    if (smsSending.current) {
      return;
    }
    try {
      smsSending.current = true;
      const resp = yield app == null ? void 0 : app.http.getComponentDetail({
        operationId: ((_a2 = app.strategyData) == null ? void 0 : _a2.operationId) || "",
        type: props.bizType,
        method: "sms" /* SMS */,
        email: app == null ? void 0 : app.email
      });
      if (resp == null ? void 0 : resp.success) {
        startSmsCountdown.current();
      } else {
        Toast.show(resp == null ? void 0 : resp.errMsg);
      }
    } catch (error) {
    } finally {
      smsSending.current = false;
    }
  });
  const submit = useCallback5((val) => __async(void 0, null, function* () {
    if (submitting.current) {
      return;
    }
    try {
      submitting.current = true;
      const result = yield validate({
        method,
        value: val
      });
      onNext(method, result, t("\u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801"), {
        fail: () => {
          var _a2, _b2;
          if (method === "sms") {
            (_a2 = smsRef.current) == null ? void 0 : _a2.clear();
          } else {
            (_b2 = emailRef.current) == null ? void 0 : _b2.clear();
          }
        }
      });
    } catch (error) {
    } finally {
      submitting.current = false;
    }
  }), [validate, onNext, t, method]);
  const onFill = useCallback5((val) => {
    submit(val);
  }, [submit]);
  useEffect10(() => {
    if (smsCountdown === INITIAL_COUNTDOWN) {
      setSmsDelay(INTERVAL);
    }
  }, [smsCountdown]);
  useEffect10(() => {
    if (emailCountdown === INITIAL_COUNTDOWN) {
      setEmailDelay(INTERVAL);
    }
  }, [emailCountdown]);
  useEffect10(() => {
    if (method === "sms") {
      sendSms();
    } else {
      sendEmail();
    }
  }, []);
  return /* @__PURE__ */ React14.createElement("div", null, method === "sms" ? /* @__PURE__ */ React14.createElement(VerifyCode, {
    ref: smsRef,
    t,
    title: t("\u77ED\u4FE1\u9A8C\u8BC1"),
    locale: props.locale,
    contact: phone,
    sendToText: t("\u77ED\u4FE1\u5C06\u53D1\u9001\u81F3"),
    switcher: t("\u90AE\u7BB1\u9A8C\u8BC1"),
    countdown: smsCountdown,
    onClickSwitcher: onSWitchToEmail,
    onResend: onResendSms,
    onFill
  }) : /* @__PURE__ */ React14.createElement(VerifyCode, {
    ref: emailRef,
    t,
    title: t("\u90AE\u7BB1\u9A8C\u8BC1"),
    locale: props.locale,
    contact: email,
    sendToText: t("\u6211\u4EEC\u5C06\u53D1\u9001\u9A8C\u8BC1\u7801\u81F3\u60A8\u7684\u90AE\u7BB1"),
    switcher: t("\u77ED\u4FE1\u9A8C\u8BC1"),
    countdown: emailCountdown,
    onClickSwitcher: onSWitchToSMS,
    onResend: onResendEmail,
    onFill
  }));
};
var SMSWithEmailVerify = withTranslation("sms_email" /* SMSWithEmail */)(SMSWithEmailImpl);

// src/components/date-of-birth/index.tsx
import React17, { useRef as useRef11, useState as useState9 } from "react";
import { dateOfBirth as styles5 } from "@al/eu-security-verify-style";

// src/components/button/index.tsx
import React15 from "react";
import classNames3 from "classnames";
import { button } from "@al/eu-security-verify-style";
var Button = (props) => {
  const _a = props, { className } = _a, rest = __objRest(_a, ["className"]);
  return /* @__PURE__ */ React15.createElement("div", __spreadProps(__spreadValues({}, rest), {
    className: classNames3(button.button, className)
  }), props.children);
};

// src/components/date-of-birth-input/index.tsx
import React16, {
  forwardRef as forwardRef3,
  useEffect as useEffect11,
  useImperativeHandle as useImperativeHandle2,
  useRef as useRef10,
  useState as useState8
} from "react";
import classNames4 from "classnames";
import { dateOfBirthInput as input2 } from "@al/eu-security-verify-style";

// src/components/date-of-birth-input/clear.png
var clear_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOkSURBVHgBzZrbVeMwEIbHAt7TwZoKlq1goQP2HcimAqACTAfZCpJweYYOCBUQKljTQd657fw+oxyT+KKRlKy/cxw7vsT/SKPRSEpCERiNRr2tra3DJEn2+Os33rDvyWbJZXvm+55eX18fB4NBToEk5AlEb29vn/Lhvmz6lyfJjHfDEGPUBpSEn9HXEg5l/Pb2dqk1RGXA9fX1BcUXvkx2fHx86XqzkwFc6unOzs7d5+fnHm2GnGvjwKU2TNsNNzc3fXaZpw2KByneeXV1ddh2Y6MBt7e3Fyx8TOt1mTp63MjvxG1rqXUhiP/4+MioG9S2i0oDUHWwnjoE6/l9dHQ0WTm/fAINFv5H/8dtmphzw/6x3LBX2gCLf6DuiQc9RMLlk18MgN/zLqWOgkg4mUyy8rmFC4nr/KXuA1faZVea48uiBjgZy8iPKfkzJT09Y8yZ/VIYgNLnVt4nJRxmLzm8HfChc9cf41k24BQ5WXGMDy79fVICAf1+P8MxC8k0QkKeFRa1UBgAizRPlwVYXIWEPFuGNf8s9nAfbZ7DNVbZ2NuEVIm3sAtrA8g+3Mj4uA/yIyR5VdfqjGgSj9+SnEsFRoHGN8vUGLEO8QBDWHYl8508cTFiXeLl/WnC6Sp8L6UA6hKtJkLFCzmiUEqBNNVEFZHEg17riMwVVyMiigfxDAAQxqGtNijgWkTxBYhCc4oEGiwnWbO663JNnTo0YbgBRjGgKdqU8Uwd6iga8YwCcRVviWhEbvjlLxRAW5zX9thKno3MT3rh0kn5pB2uYJLYvL+/35MHmh52XUZgUtjI0GxKOuZswLjqQl2cbzKCh4hjbTTk+2eYobD9wCPpwAz1A1Lx8sm2TqrKCBmLP7A7qGZCOIcbFnt8cAkMPfqDtGyEaw9bNsKKJ490Bu6D/WJWgpO6jHcXpCfnbSibM2hDXIowJCU9Y247AxwsUgnPWiARoBJfvNgY7zkoLIQsfsceoDGzH/6hjiPpSm6/r8yN8sTukyzWdQ72kPzk5GS3fG4lG+V+4VfMBC8W0MTaDpbPrxgg1XNO3WNQteRUOR7gahpT5LQ3BPg9a6rMGBoX+QJCazTaMt3WVUpZaBtpe8pQpB2eizfU4rzMypNI6O5T2gDIcxBMXJZZtQvdGa3RpVDq6IskQ3XC568GqI3MZzq+Disc2YBduHAl5M8eqcyrngZ0fFPeHn2EW7wNKGONEUMwVZlSKc+REoZAjP5exMfvfUWX+QfW/FsthKuefwAAAABJRU5ErkJggg==";

// src/components/date-of-birth-input/index.tsx
var defaultProps2 = {
  defaultValue: "",
  length: 8,
  clearable: true
};
var DateOfBirthInput = forwardRef3((p, ref) => {
  var _a;
  const props = mergeProps(defaultProps2, p);
  const cellLength = props.length > 0 && props.length < Infinity ? Math.floor(props.length) : defaultProps2.length;
  const [focused, setFocused] = useState8(false);
  const [value, setValue] = useState8((_a = props.value) != null ? _a : props.defaultValue);
  const rootRef = useRef10(null);
  const nativeInputRef = useRef10(null);
  const onFocus = () => {
    var _a2, _b;
    (_a2 = nativeInputRef.current) == null ? void 0 : _a2.focus();
    setFocused(true);
    (_b = props.onFocus) == null ? void 0 : _b.call(props);
  };
  const onBlur = () => {
    var _a2;
    setFocused(false);
    (_a2 = props.onBlur) == null ? void 0 : _a2.call(props);
  };
  useEffect11(() => {
    var _a2;
    setValue((_a2 = props.value) != null ? _a2 : props.defaultValue);
  }, [props.value, props.defaultValue]);
  useEffect11(() => {
    var _a2;
    if (value.length >= cellLength) {
      (_a2 = props.onFill) == null ? void 0 : _a2.call(props, value);
    }
  }, [value, cellLength]);
  useImperativeHandle2(ref, () => ({
    focus: () => {
      var _a2;
      return (_a2 = rootRef.current) == null ? void 0 : _a2.focus();
    },
    blur: () => {
      var _a2, _b;
      (_a2 = rootRef.current) == null ? void 0 : _a2.blur();
      (_b = nativeInputRef.current) == null ? void 0 : _b.blur();
    }
  }));
  const cls = classNames4(input2.container, {
    [input2.focused]: focused,
    [input2.highlight]: focused || value
  });
  const renderCells = () => {
    const cells = [];
    const chars = value.split("");
    const caretIndex = chars.length;
    for (let i = 0; i < cellLength + 1; i++) {
      cells.push(/* @__PURE__ */ React16.createElement("div", {
        className: classNames4(input2.cell, {
          [input2.cellWithCaret]: caretIndex === i && focused,
          [input2.cellNoChar]: !chars[i] && i < cellLength
        }),
        key: i
      }, chars[i]));
      if (i === 1 || i === 3) {
        cells.push(/* @__PURE__ */ React16.createElement("div", {
          className: input2.dot
        }));
      }
    }
    return cells;
  };
  return /* @__PURE__ */ React16.createElement("div", {
    ref: rootRef,
    className: cls,
    tabIndex: 0,
    onFocus,
    onBlur
  }, /* @__PURE__ */ React16.createElement("div", {
    className: input2.cellContainer
  }, renderCells()), /* @__PURE__ */ React16.createElement("label", {
    className: input2.label,
    style: props.labelStyle
  }, props.label), props.clearable && !!value && focused ? /* @__PURE__ */ React16.createElement("div", {
    className: input2.clear,
    onMouseDown: (e) => {
      e.preventDefault();
    },
    onClick: () => {
      var _a2;
      setValue("");
      (_a2 = props.onClear) == null ? void 0 : _a2.call(props);
    }
  }, /* @__PURE__ */ React16.createElement("img", {
    className: input2.clearImg,
    src: clear_default,
    alt: ""
  })) : null, /* @__PURE__ */ React16.createElement("input", {
    ref: nativeInputRef,
    value,
    className: input2.nativeInput,
    pattern: "[0-9]*",
    inputMode: "numeric",
    onChange: (e) => {
      if (isNaN(Number(e.target.value))) {
        return;
      }
      setValue(e.target.value.slice(0, props.length));
    }
  }));
});

// src/components/date-of-birth/index.tsx
var DateOfBirthVerifyImpl = (props) => {
  const { t } = props;
  const [value, setValue] = useState9("");
  const submitting = useRef11(false);
  const submit = () => __async(void 0, null, function* () {
    if (submitting.current) {
      return;
    }
    submitting.current = true;
    const result = yield props.validate({
      method: "birthday" /* DateOfBirth */,
      value
    });
    submitting.current = false;
    props.onNext("birthday" /* DateOfBirth */, result, t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F"));
  });
  const onFill = (val) => {
    setValue(val);
  };
  const onSubmit = () => __async(void 0, null, function* () {
    if (!value) {
      Toast.show(t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u51FA\u751F\u65E5\u671F"));
      return;
    }
    submit();
  });
  return /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(Title, {
    title: t("\u8EAB\u4EFD\u9A8C\u8BC1")
  }), /* @__PURE__ */ React17.createElement("div", {
    className: styles5.subTitle
  }, t("\u60A8\u7684\u5E10\u6237\u662F\u4E00\u7B14\u5B9D\u8D35\u7684\u8D44\u4EA7\u3002\u4E3A\u4E86\u4FDD\u62A4\u60A8\u5E10\u6237\u5B89\u5168\u6027\uFF0C\u6211\u4EEC\u9700\u8981\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD")), /* @__PURE__ */ React17.createElement(DateOfBirthInput, {
    label: t("\u51FA\u751F\u65E5\u671F\uFF08DD/MM/YYYY)"),
    onFill
  }), /* @__PURE__ */ React17.createElement("div", {
    className: styles5.actions
  }, /* @__PURE__ */ React17.createElement(Button, {
    onClick: onSubmit
  }, t("\u63D0\u4EA4"))));
};
var DateOfBirthVerify = withTranslation("birthday" /* DateOfBirth */)(DateOfBirthVerifyImpl);

// src/components/distributor/config.ts
var COMPONENTS_MAP = {
  ["sms" /* SMS */]: {
    component: SMSVerify
  },
  ["image" /* Slider */]: {
    component: SliderVerify
  },
  ["email" /* Email */]: {
    component: EmailVerify
  },
  ["sms_email" /* SMSWithEmail */]: {
    component: SMSWithEmailVerify
  },
  ["birthday" /* DateOfBirth */]: {
    component: DateOfBirthVerify
  }
};

// src/components/distributor/index.tsx
var Distributor = (p) => {
  var _a, _b;
  const app = useApp();
  if (!(app == null ? void 0 : app.strategyData)) {
    return null;
  }
  const componentData = (_b = (_a = app == null ? void 0 : app.strategyData) == null ? void 0 : _a.validComponents) == null ? void 0 : _b[p.step];
  if (!componentData) {
    return null;
  }
  const componentInfo = COMPONENTS_MAP[componentData.method];
  if (!componentInfo) {
    return null;
  }
  const { component: Comp } = componentInfo;
  const props = {
    locale: p.locale,
    bizType: p.bizType,
    validate: p.validate,
    email: p.email,
    phone: p.phone,
    onNext: p.onNext,
    onRequestError: p.onRequestError
  };
  return /* @__PURE__ */ React18.createElement(Comp, __spreadValues({}, props));
};

// src/components/too-frequently/index.tsx
import React19 from "react";
import { tooFrequently as styles6 } from "@al/eu-security-verify-style";
var TooFrequently2 = (props) => {
  const { t } = props;
  return /* @__PURE__ */ React19.createElement("div", {
    className: styles6.tooFrequently
  }, /* @__PURE__ */ React19.createElement("img", {
    className: styles6.frequentImg,
    src: timer_default
  }), /* @__PURE__ */ React19.createElement("p", {
    className: styles6.frequentText
  }, t("\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5")));
};

// src/components/navbar/index.tsx
import React20 from "react";
import { navbar } from "@al/eu-security-verify-style";

// src/components/navbar/back-arrow.png
var back_arrow_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAwCAYAAADtoXHnAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM8SURBVHgB1Vi/cxJBFH5HnEErflR2EKDIUGFoHBtPGu3EVHZS2ZrkH8jFysqktTKWNprKkUbIP2CwoYM7OzqQgh/DDPi988ATuN09uHMm38wOd7fv9uP2fe/t7tuhEFEsFikajZaTyeTLbrdbnT/foZCQy+VoOBweapr2Hrf3E4kEgfgqNNJ8Pq9NJpMzXBrOIw3tIb7YAvGPQEkNwyDLshLT6fQLbp8vddvEsVisqlFA0HWdCXcxnd/Q0gJTMxBSTCcNBoN7IPskIbRJIxQA4Xg8rkQiEdkX0mw2u8bUl7YiLRQKNBqNDAzGCo2TmPACrQQXWLdoC/T7fSarKJiemqZpzG82Ik0DmMrPuCxITGdox+12+9z90LeQHMKagmC68N8BZrO+3OErTpFldPww4V2JqQnCByBsrOtUFlImk3mFgWokF0wNdvssGC8bJZ+C8IT+pjQRziGYI5mRkBTuizsJu0xynEIwhoKdt5DmCkWTKbQLm+NWq3VBitA8CAsOYZrEMB2FNsgHVoSUzWZfIKXVFFJag1OaX8IVUhYMpyuSK/QS7ZFIoSIsppd9iC80Fd5RFowXFurlLKNgf7Sc0jYm5UwD/6QFdj30P1uX0jYmxYCisLDQv7H/1sEWEkThSRo04YL0f8MmhYg8Y41jlpVNQZNiCkUBzqF0DV6dAoK9nvZ6PSsej+uCLHQbfRX3Ln1rUgZIf/LAEns9COIFKX8tBvyFyyeSd3T8wQJaFe+MaAOsrDLwXRk+lG4paYv49VraVDdfprPSWOQDa+OUB+FVBM0iMXYxK995OSQf8NwNwl89+O0DLvfwxXvkjTtoT/0ITLgFZaGgfcSA7AZdYGr3wy7mPnGLjJWABf4QP2cyOz4koR2I/Oxrh89ZCT7k44RM2UKBhXms8Ny0+V5lXMqWbchsZTtu+Qcb1Rx6f/AuwZJF5URgyjP5eFnZWxU6UqnUV5zCVZWdQpHjiiNi65oD14vgOz6/vFUwtwV2MwsdjGazyarm+CwppM7g9kj1ep0qlYoJ0n3cXnqYzTiMAiteucFVFxRBDFyeuAnJqT+EUhvsdDqs7PqSsl+D8A2FDS698qYACcJwP/8NOJ6iUDnKxkcAAAAASUVORK5CYII=";

// src/components/navbar/index.tsx
var NavBar = (props) => {
  return /* @__PURE__ */ React20.createElement("div", {
    className: `${navbar.nav}`
  }, /* @__PURE__ */ React20.createElement("div", {
    className: navbar.backContainer,
    onClick: props.onBack
  }, props.backIcon ? props.backIcon : /* @__PURE__ */ React20.createElement("img", {
    className: navbar.image,
    src: back_arrow_default,
    alt: ""
  })), /* @__PURE__ */ React20.createElement("div", {
    className: navbar.title
  }, props.title));
};

// src/hooks/use-theme.ts
import classNames5 from "classnames";
import { mobileTheme, payTheme } from "@al/eu-security-verify-style";
function useTheme(theme) {
  let t = mobileTheme;
  if (theme === "pay") {
    t = payTheme;
  }
  const themeArr = Object.keys(t).map((k) => t[k]);
  return classNames5(themeArr);
}

// src/verifyHOC.tsx
function verifyHOC(options) {
  return (WrappedComponent) => {
    const VerifyContainer = (props) => {
      const { onRequestError, onRejected } = props;
      const [loading, setLoading] = useState10(true);
      const [fetchListEnd, setFetchListEnd] = useState10(false);
      const [strategyData, setStrategyData] = useState10();
      const [status, setStatus] = useState10("unknown" /* Unknown */);
      const [step, setStep] = useState10(0);
      const theme = useTheme(props.theme);
      const initHttp = () => {
        let options2;
        if (typeof props.apiBaseURL !== "undefined") {
          options2 = {
            baseURL: props.apiBaseURL
          };
        } else {
          options2 = {
            baseURL: "/mapi"
          };
        }
        if (props.debug) {
          options2 = {
            baseURL: props.env === "prod" ? "https://m.silvrr.com/mapi" : `https://${props.env}-m.silvrr.com/mapi`
          };
        }
        return new Http(__spreadProps(__spreadValues({}, options2), {
          headers: {
            "device-id": props.deviceId,
            deviceUUID: props.deviceUuid || props.deviceId,
            "channel-id": props.channelId,
            "device-type": props.deviceType,
            "country-id": props.countryId || cookie.get("countryId") || "5",
            "language-id": props.languageId || cookie.get("languageId") || "150"
          }
        }));
      };
      const http = useRef12(initHttp());
      const onSuccess = (resp) => {
        let operationId = "";
        if (resp) {
          operationId = resp.operationId;
        } else if (strategyData) {
          operationId = strategyData.operationId;
        }
        props.onSuccess({
          operationId
        });
      };
      const onNext = (method, result, errMsg, callbacks) => __async(this, null, function* () {
        var _a, _b, _c, _d, _e, _f;
        const component = (_b = (_a = result == null ? void 0 : result.data) == null ? void 0 : _a.validComponents) == null ? void 0 : _b.find((c) => c.method === method);
        if (component) {
          if (transformStatus((_c = component == null ? void 0 : component.status) != null ? _c : 1) === "pass" /* Pass */) {
            if (step + 1 < (((_d = strategyData == null ? void 0 : strategyData.validComponents) == null ? void 0 : _d.length) || 0)) {
              setStep(step + 1);
            } else {
              onSuccess();
            }
            (_e = callbacks == null ? void 0 : callbacks.success) == null ? void 0 : _e.call(callbacks);
          } else {
            Toast.show(errMsg);
            (_f = callbacks == null ? void 0 : callbacks.fail) == null ? void 0 : _f.call(callbacks);
          }
        }
      });
      const fetchVerifications = () => __async(this, null, function* () {
        var _a, _b, _c;
        const { bizType, extraParams } = props;
        const params = __spreadValues({
          type: bizType
        }, extraParams);
        try {
          const resp = yield (_a = http.current) == null ? void 0 : _a.fetchVerifications(params, props.fetchListUrl);
          (_b = props.onFetchListEnd) == null ? void 0 : _b.call(props, resp);
          if ((resp == null ? void 0 : resp.success) && (resp == null ? void 0 : resp.data)) {
            const status2 = transformStatus(resp.data.validStatus);
            if (status2 !== "unknown" /* Unknown */) {
              if (status2 === "pass" /* Pass */) {
                setStrategyData(resp.data);
                onSuccess(resp == null ? void 0 : resp.data);
              } else if (status2 === "rejected" /* Rejected */ || status2 === "rejectedWithoutRetry" /* RejectedWithoutRetry */) {
                onRejected == null ? void 0 : onRejected();
                setStatus("rejectedWithoutRetry" /* RejectedWithoutRetry */);
              } else {
                setStrategyData(resp.data);
                setStatus(status2);
              }
              setLoading(false);
            } else {
              Toast.show("Unexpected status");
            }
          } else {
            setLoading(false);
            setStatus("rejectedWithoutRetry" /* RejectedWithoutRetry */);
          }
        } catch (error) {
          (_c = props.onFetchListEnd) == null ? void 0 : _c.call(props);
          onRequestError == null ? void 0 : onRequestError({
            type: "componentList",
            error
          });
        } finally {
          setFetchListEnd(true);
          setStep(0);
        }
      });
      const validate = (params) => __async(this, null, function* () {
        var _a;
        const rest = __objRest(params, []);
        try {
          const resp = yield (_a = http.current) == null ? void 0 : _a.validate({
            operationId: (strategyData == null ? void 0 : strategyData.operationId) || "",
            type: props.bizType,
            email: props.email,
            validComponents: [rest]
          });
          if (!resp.success) {
            setStatus("rejectedWithoutRetry" /* RejectedWithoutRetry */);
            return;
          }
          return resp;
        } catch (error) {
        }
      });
      useEffect12(() => {
        fetchVerifications();
      }, []);
      const renderContent = () => {
        const phone = (strategyData == null ? void 0 : strategyData.helpText.enPhone) || `${props.countryCode || ""} ${props.phoneNumber || ""}` || "";
        switch (status) {
          case "pending" /* Pending */:
            return /* @__PURE__ */ React21.createElement(Distributor, {
              locale: props.locale,
              bizType: props.bizType,
              step,
              email: props.email,
              phone,
              validate,
              onNext,
              onRequestError
            });
          case "rejectedWithoutRetry" /* RejectedWithoutRetry */:
            return /* @__PURE__ */ React21.createElement(TooFrequently2, {
              t: props.t
            });
          default:
            return null;
        }
      };
      return /* @__PURE__ */ React21.createElement(AppContext.Provider, {
        value: {
          http: http.current,
          strategyData,
          email: props.email,
          bizType: props.bizType
        }
      }, /* @__PURE__ */ React21.createElement(WrappedComponent, null, /* @__PURE__ */ React21.createElement("div", {
        className: theme
      }, props.navBar ? props.navBar : /* @__PURE__ */ React21.createElement(NavBar, {
        backIcon: props.navBackIcon,
        title: props.navTitle,
        onBack: () => {
          var _a;
          if (!fetchListEnd) {
            return;
          }
          (_a = props.onClose) == null ? void 0 : _a.call(props);
        }
      }), props.brand, loading || !props.deviceId || !props.deviceUuid ? null : renderContent())));
    };
    return withTranslation("global")(VerifyContainer);
  };
}
export {
  FormattedStatus,
  SecurityMethodFlag,
  set as setToast,
  verifyHOC,
  withTranslation
};
